angular.module("digitalLeasing.module").component("goodDetail", {
  templateUrl: "ng/components/digitalLeasing/leasingHypothesis/goodDetail/goodDetail.view.html",
  bindings: {
    model: "=",
    onGoodChanges: "&?",
    product: "<",
    goodIsOk: '&',
    goodIsNotOk: '&',
    snapshot: '<',
    vendor: '<',
    upgradeModPag: '&',
    marcaMandatory: '<'
  },
  controllerAs: "GoodDetailCtrl",
  controller: GoodDetailController
});

function GoodDetailController(
  $financialApiService,
  MarcaVeicolo,
  $scope,
  $rootScope,
  $typeDomainService,
  Motorizzazione
) {
  var self = this;
  self.$rootScope = $rootScope;
  self.supportModel = {
    brand: '',
    underCostruction: 'No',
    models: '',
    modelSelected: '',
    motorizzazione: [],
    alimentazione: ''
  };
  self.validationObj = {
    documentDate: {
      disabledDays: [0],
      disabledDates: [
        "01-01",
        "06-01",
        "25-04",
        "01-05",
        "02-06",
        "15-08",
        "01-11",
        "08-12",
        "25-12",
        "26-12"
      ]
    }
  };
  self.$onInit = function () {

    if (self.model.preventivo.prodotto.bene.marcaVeicolo.modello && self.model.preventivo.prodotto.bene.marcaVeicolo.modello.length == 1 &&
      self.model.preventivo.prodotto.bene.marcaVeicolo.modello[0] && self.model.preventivo.prodotto.bene.marcaVeicolo.modello[0].description) {
      self.isOnInit = true;
    }
    if (self.model.preventivo.prodotto.bene.marcaVeicolo != "") {
      self.supportModel.models = self.model.preventivo.prodotto.bene.marcaVeicolo.modello;
    }

    if (self.model.preventivo.prodotto.bene && self.model.preventivo.prodotto.bene.motorizzazione && self.model.preventivo.prodotto.bene.motorizzazione.id) {
      self.supportModel.alimentazione = self.model.preventivo.prodotto.bene.motorizzazione;
    }
    listOfMotorizzazione();
  };

  self.$onChanges = function (changed) {
    if (changed && changed.product && changed.product.currentValue) {
      if (self.product.id && self.product.isTargato) {
        self.supportModel.brand = "";
        if (typeof self.model.preventivo.prodotto.bene.pagobollo == "undefined") {
          self.model.preventivo.prodotto.bene.pagobollo = true;
          self.model.preventivo.prodotto.bene.inAllestimento = false;
        }

        getListofBrand(self.product.id);
        validateAccordion();
      }

    }
    if (self.model.preventivo.prodotto.bene && self.model.preventivo.prodotto.bene.marcaVeicolo && self.model.preventivo.prodotto.bene.marcaVeicolo.id) {
      self.supportModel.brand = self.model.preventivo.prodotto.bene.marcaVeicolo;
    }
    if (self.model.preventivo.prodotto.bene && self.model.preventivo.prodotto.bene.motorizzazione && self.model.preventivo.prodotto.bene.motorizzazione.description) {
      self.supportModel.alimentazione = self.model.preventivo.prodotto.bene.motorizzazione;
    } else {
      self.supportModel.alimentazione = '';
    }
  };

  self.handleGoodChange = function (property, value) {
    switch (property) {
      case "year":
        var currentYear = new Date().getFullYear();
        value = parseInt(value);
        if (self.model.preventivo.prodotto.bene.annoCostruzione > currentYear) {
          self.errorYear = true;
          $scope.formGoodDetail['constructionYearId'].$setValidity('constructionYearId', false);
          jQuery('#constructionYearId').addClass('has-error');
        } else {
          self.errorYear = false;
          $scope.formGoodDetail['constructionYearId'].$setValidity('constructionYearId', true);
          jQuery('#constructionYearId').removeClass('has-error');
        }

        validateAccordion();
        break;

      case "status":
        self.model.preventivo.prodotto.bene.stato = value;
        self.model.preventivo.prodotto.bene.statoCaricamento = value;
        var usato = self.model.preventivo.prodotto.bene.stato == 'LBL_GOOD_STATE_NOT_NEW' ? true : false;
        newOrUsed(self.model.preventivo.prodotto.id, self.vendor.reteVendita, self.model.preventivo.cdRaggrConvenzione, usato);
        validateAccordion();
        break;


      case "description":
        self.model.preventivo.prodotto.bene.descrizione = value;
        validateAccordion();
        break;

      case 'marcaVeicolo':
        if (!value) {
          self.model.product.bene.marcaVeicolo.modello = [];
          self.supportModel.modelSelected = "";
          self.supportModel.alimentazione = "";
          self.model.preventivo.prodotto.bene.motorizzazione = Motorizzazione.build();
          self.model.preventivo.prodotto.bene.marcaVeicolo = MarcaVeicolo.build();
        } else {

          self.supportModel.models = value.modello;
          self.supportModel.modelSelected = "";
          self.model.preventivo.prodotto.bene.marcaVeicolo = MarcaVeicolo.build({
            id: value.id,
            description: value.description
          });
        }
        validateAccordion();
        break;

      case 'modello':
        self.model.product.bene.marcaVeicolo.modello = [];
        self.model.product.bene.marcaVeicolo.modello.push(value);
        validateAccordion();
        break;
      case 'motorizzazione':
        if (value) {
          self.model.preventivo.prodotto.bene.motorizzazione = Motorizzazione.build({
            id: value.value,
            description: value.description,
            selected: true
          });
        } else {
          self.model.preventivo.prodotto.bene.motorizzazione = Motorizzazione.build();
        }

      default:
        validateAccordion();
        break;
    }
    self.onGoodChanges({
      good: self.model
    });
  };

  var getListofBrand = function (codProdotto) {
    if (self.snapshot) {
      self.supportModel.modelSelected = self.model.preventivo.prodotto.bene.marcaVeicolo.modello[0];
      return;
    }
    $financialApiService
      .getlistOfCarBrands(codProdotto)
      .then(function (brandsList) {
        self.supportModel.brandsList = brandsList;
        if (self.isOnInit) {
          self.isOnInit = false;
          self.supportModel.modelSelected = self.model.preventivo.prodotto.bene.marcaVeicolo.modello[0];
          self.supportModel.models = self.supportModel.brandsList
            .find(function (e) {
              return e.description == self.model.preventivo.prodotto.bene.marcaVeicolo.description;
            }).modello
        } else {
          if (self.product.id != 'AVI') {
            self.supportModel.modelSelected = undefined;
            self.model.preventivo.prodotto.bene.marcaVeicolo.modello = []
          }
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  var validateAccordion = function () {

    var test = self.model.preventivo.prodotto.bene && !!self.model.preventivo.prodotto.bene.annoCostruzione

    if (self.product.isTargato && self.marcaMandatory) {

      test = test && !!self.model.preventivo.prodotto.bene.marcaVeicolo.id;
    }


    if (test && !self.errorYear) {
      self.goodIsOk();
    } else {
      self.goodIsNotOk();
    }
  }

  var newOrUsed = function (idProdotto, reteVendita, cdRaggrConvenzione, usato) {

    $financialApiService
      .providerPaymentModes(idProdotto, reteVendita, cdRaggrConvenzione, usato, self.vendor.riUserG.ndg)
      .then(function (response) {
        self.upgradeModPag({
          modPagamento: response.modPagamento
        });
      })
      .catch(function (error) {

      })
  }

  var listOfMotorizzazione = function () {
    $typeDomainService.getDomainSet('BENE', 'MOTORIZZAZIONE')
      .then(function (response) {
        self.supportModel.motorizzazione = response.domainList;
      })
  }

}